<template>
  <div class="product-detail">
    <div class="product-detail-box">
      <div class="product-detail-title">
        <img :src="url">
        <div class="info">
          <div class="info-title">{{ $t('productCenter.tabs.ahiFoam') }}</div>
          <div class="info-text">{{ productDescription }}</div>
          <el-button 
            style="height: 43px;"
            type="primary" 
            @mouseenter.native="mouseenter" 
            @mouseleave.native="mouseleave"
          >
            {{ btnText }}
            <img 
              v-if="showcloudDownloadImg" 
              style="margin-right: 0;height: 15px;position: relative;top: 2px;" 
              :src="cloudDownload"
            >
          </el-button>
        </div>
      </div>
    </div>
    <div class="product-detail-info">
      <div class="list">
        <div class="list-title">{{ $t('productCenter.common.productFeatures') }}</div>
        <div class="list-item" v-for="feature in productFeatures" :key="feature">
          <span></span><p>{{ feature }}</p>
        </div>
      </div>
          
      <div class="list">
        <div class="list-title">{{ $t('productCenter.common.typicalApplications') }}</div>
        <div class="list-item" v-for="application in typicalApplications" :key="application">
          <span></span><p>{{ application }}</p>
        </div>
      </div>

      <div class="table">
        <div class="table-title">{{ $t('productCenter.common.technicalParameters') }}</div>
        <el-table
          :data="tableData"
          stripe
          border
          style="width: 100%">
            <el-table-column
              prop="project"
              :label="$t('productCenter.common.project')"
              width="190">
              <template slot-scope="scope">
                <span class="multiline">{{ scope.row.project.replace(/｜/g, '\n') }}</span>
              </template>
            </el-table-column>
            <el-table-column
              prop="test"
              :label="$t('productCenter.common.testMethod')"
              align="center"
              width="233">
            </el-table-column>
            <el-table-column
              prop="parameter1"
              align="center"
              width="194"
              label="AHI-0501">
            </el-table-column>
            <el-table-column
              prop="parameter2"
              align="center"
              width="194"
              label="AHI-1001">
            </el-table-column>
            <el-table-column
              prop="parameter3"
              align="center"
              width="194"
              label="AHI-2001">
            </el-table-column>
            <el-table-column
              prop="parameter4"
              align="center"
              width="194"
              label="AHI-3001">
            </el-table-column>
        </el-table>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  data () {
    return {
      url: require('@/assets/images/productCenter/product11.png'),
      cloudDownload: require('@/assets/images/cloud-download.png'),
      showcloudDownloadImg: true
    }
  },
  computed: {
    productDescription () {
      return this.$t('productCenter.product11.description')
    },
    btnText () {
      return this.showcloudDownloadImg 
        ? this.$t('productCenter.downloadManual')
        : this.$t('productCenter.contactForMore')
    },
    productFeatures () {
      return this.$t('productCenter.product11.features')
    },
    typicalApplications () {
      return this.$t('productCenter.product11.applications')
    },
    tableData () {
      const data = this.$t('productCenter.product11.tableData')
      return data.map(item => ({
        project: item.project,
        test: item.test,
        parameter1: item.parameter1,
        parameter2: item.parameter2,
        parameter3: item.parameter3,
        parameter4: item.parameter4
      }))
    }
  },
  methods: {
    mouseenter () {
      this.showcloudDownloadImg = false
    },
    mouseleave () {
      this.showcloudDownloadImg = true
    }
  }
}
</script>

<style lang="scss" scoped>
.product-detail {
  .product-detail-box {
    padding: 60px 0;
    background: rgb(248, 250, 253);
  }
  .product-detail-title {
    width: 1200px;
    margin: 0 auto;
    display: flex;
    img {
      margin-right: 40px;
    }
    .info {
      .info-title {
        font-weight: 500;
        font-size: 24px;
        line-height: 34px;
        padding-bottom: 30px;
      }
      .info-text {
        font-weight: 400;
        font-size: 18px;
        line-height: 25px;
        color: rgba(43, 50, 71, 0.7);
        padding-bottom: 30px;
      }
      .el-button {
        background-color: #fff;
        color: rgb(28, 100, 215);
        border-color: rgb(28, 100, 215);
        i {
          display: inline-block;
        }
      }
    }
  }
  .product-detail-info {
    width: 1200px;
    margin: 0 auto;
    padding: 0 0 100px;
    .list {
      padding-top: 60px;
      .list-title {
        font-weight: 500;
        font-size: 24px;
        line-height: 34px;
        padding-bottom: 24px;
      }
      .list-item {
        font-weight: 400;
        font-size: 18px;
        line-height: 25px;
        color: rgba(43, 50, 71, 0.7);
        display: flex;
        align-items: center;
        p {

        }
        span {
          width: 4px;
          height: 4px;
          border-radius: 50%;
          background-color: rgba(43, 50, 71, 0.7);
          margin-right: 8px;
        }
      }
    }
    .table {
      padding-top: 60px;
      .table-title {
        margin-bottom: 24px;
        font-weight: 500;
        font-size: 24px;
        line-height: 34px;
      }
      ::v-deep .el-table__header th {
        background-color: #f5f7fa;
        text-align: center;
        color: rgb(43, 50, 71);
      }
      ::v-deep .el-table--striped .el-table__body tr.el-table__row--striped td.el-table__cell {
        background-color: #f5f7fa;
      }
      ::v-deep .el-table__body td {
        color: rgba(43, 50, 71, 0.7);
      }
      .customTable {
        ::v-deep thead tr:last-child {
          display: none;
        }
      }
      .multiline {
        white-space: pre-line;
        color: rgb(43, 50, 71);
        font-weight: 500;
      }
      .annotation {
        font-weight: 400;
        font-size: 18px;
        line-height: 25px;
        padding-top: 12px;
        color: rgb(43, 50, 71);
      } 
    }
  }
}
</style>